export const OPPreviewContainer = `flex flex-col text-center p-6 md:py-20 md:px-28`
export const OPPreviewParagraph = `mb-4 text-xl`
export const OPPreviewNumberContainer = `mb-6 flex flex-col items-center`
export const OPPreviewNumber = `cursor-pointer md:pointer-events-none md:cursor-default mb-4 flex items-center`
export const OPPreviewAvailableHours = `text-xs w-full max-w-[300px]`

